import { render, staticRenderFns } from "./detail-button.vue?vue&type=template&id=3d080102&scoped=true"
import script from "./detail-button.vue?vue&type=script&lang=js"
export * from "./detail-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d080102",
  null
  
)

export default component.exports